'use strict';
/* global angular _ */

import extend from 'lodash/extend';

/**
 * Error messaging service, responsible for dispatching error messages.
 */
angular.module('atex.aceui.service').factory('ErrorMessagingService',
  ['$rootScope', '$location', 'Application', function ($rootScope, $location, Application) {

    return {
      /**
       * Broadcasts an 'error:new' event on $rootScope.
       *
       * @param error An object like atex.aceui.error.Error
       * @param resolutions A list of possible resolution actions to present to the user
       *
       * @returns The id of the error. This can be used to withdraw the error later.
       */
      sendError: function (error, resolutions) {
        error = extend(atex.aceui.error.Error(), error);

        if (error.severity === atex.aceui.error.severities.CRITICAL) {
          Application.currentErrorInfo = { error };
          $location.path('/error');
          $location.replace();
        }

        if (error.severity === atex.aceui.error.severities.MAJOR) {
          console.error ('ERROR: ', error);
        }

        if (resolutions) {
          error.action = [];

          Object.entries(resolutions).forEach(([key, value]) => {
            error.action.push ({
              label: key,
              action: value
            });
          });
        }

        $rootScope.$broadcast('error:new', error);

        return error.id;
      },

      clearErrors: function () {
        $rootScope.$broadcast('error:clear');
      },

      /**
       * Broadcasts a 'error:withdraw' event on $rootScope.
       *
       * @param id Id of the error to withdraw.
       */
      withdrawError: function (id) {
        $rootScope.$broadcast('error:withdraw', id);
      }
    };
  }]
);
